<template>
  <section class="role-description-section">
    <div class="container">
      <div>
        <p class="members-only">Members-only role</p>
        <h2 class="page-title">{{ page.title }}</h2>

        <div class="tech-stacks">
          <div
            v-for="skill in page.skills"
            :key="skill"
            class="tech-stack"
          >
            {{ skill }}
          </div>
        </div>

        <div class="benefits">
          <div class="benefit">
            <div class="benefit-icon globe-icon" />
            100% remote
          </div>
          <div class="benefit">
            <div class="benefit-icon clock-icon" />
            Long term job
          </div>
          <div class="benefit">
            <div class="benefit-icon watch-icon" />
            {{ page.timezone }}
          </div>
        </div>

        <div class="role-description">
          <div v-html="page.description" />
          <div
            v-if="page.title"
            class="apply-now"
          >
            <p>
              Apply now to get matched with the best remote
              {{ page.title }} roles
            </p>
            <ApplyButton
              cta-section="apply-now-component"
              page-name="role-page"
              class="proxify-btn proxify-btn-dark proxify-btn-dark-hover-white"
            />
          </div>
        </div>
      </div>

      <SliderCard
        class="our-stories"
        :other-stories="page.stories"
        title=""
        social-page-name="role"
      />
    </div>
  </section>
</template>

<script>
import SliderCard from '~/components/StoryPage/ContentSection/SliderCard/SliderCard.vue';
import ApplyButton from '~/components/Common/ApplyButton/ApplyButton.vue';

export default {
  components: { ApplyButton, SliderCard },
  props: {
    page: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import './RoleDescriptionSection.scss';
</style>
